import { getAPI } from "./base";

// Overview
export const fetchSpendOverview = async (formValues) =>
  fetchSpend("overview", formValues);

// Spend by Supplier
export const fetchSpendBySupplier = async (formValues) =>
  fetchSpend("spend-by-supplier", formValues);

export const fetchSpendByBusinessUnit = async (formValues) =>
  fetchSpend("spend-by-business-unit", formValues);

export const fetchSpendByDepartment = async (formValues) =>
  fetchSpend("spend-by-department", formValues);

export const fetchSpendL3Insights = async (formValues) =>
  fetchSpend("l3-insights", formValues);

export const fetchSpendProcurementLevers = async (formValues) =>
  fetchSpend("procurement-levers", formValues);

export const fetchSpendCostDrivers = async (formValues) =>
  fetchSpend("cost-drivers", formValues);

export const fetchSpendInflationOverview = async (formValues) =>
  fetchSpend("inflation-overview", formValues);

export const fetchSpendCommodityInflation = async (formValues) =>
  fetchSpend("commodity-inflation", formValues);

async function fetchSpend(path, formValues) {
  try {
    const api = getAPI();
    const params = {
      L1: formValues.L1 ?? formValues.category,
      L2: formValues.L2,
      L3: formValues.L3,
      Country: formValues.country,
    };

    const response = await api.get(`/spend/${path}`, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching data: ", error);
    throw error;
  }
}
